<template>
  <component :is="componentLayout" class="select-list">
    <slot name="header">
      <component :is="componentHeader">
        <div class="text-h6 mt-4">{{ title }}</div>
      </component>
    </slot>
    <component :is="componentContent">
      <draggable handle=".drag-handle" v-model="valueList">
        <v-row class="item" dense align="center" v-for="(item, index) in valueList" :key="index">
          <v-col cols="1" class="drag-handle">
            <v-icon class="drag-icon">mdi-arrow-up-down-bold</v-icon>
          </v-col>
          <v-col cols="8">
            <v-select :label="`${label}#${index + 1}`" :value="item" @input="onInputItem($event, index)" :items="options"
              :item-disabled="item => isItemDisabled(item, index)" hide-details></v-select>
          </v-col>
          <v-col cols="3" class="text-right item-action">
            <v-btn color="secondary" outlined @click="onDelete(index)">删除</v-btn>
          </v-col>
        </v-row>
      </draggable>
      <v-row>
        <v-col>
          <v-btn color="secondary" outlined @click="onAdd">添加{{ label }}</v-btn>
        </v-col>
      </v-row>
    </component>
  </component>
</template>

<script>
import draggable from 'vuedraggable'
import { VExpansionPanel, VExpansionPanelHeader, VExpansionPanelContent } from 'vuetify/lib/components'

export default {
  components: {
    draggable,
    VExpansionPanel,
    VExpansionPanelHeader,
    VExpansionPanelContent,
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    value: {
      type: Array,
      required: false,
    },
    options: {
      type: Array,
      required: true,
    },
    expansion: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    valueList: {
      get() {
        return this.value || []
      },
      set(value) {
        this._emitValue(value)
      },
    },
    componentLayout() {
      return this.expansion ? 'v-expansion-panel' : 'div'
    },
    componentHeader() {
      return this.expansion ? 'v-expansion-panel-header' : 'div'
    },
    componentContent() {
      return this.expansion ? 'v-expansion-panel-content' : 'div'
    },
  },
  methods: {
    isItemDisabled(item, index) {
      if (item.value === this.valueList[index]) { return false }
      return this.valueList.indexOf(item.value) >= 0
    },
    _emitValue(value) {
      this.$emit('input', value)
    },
    onDelete(index) {
      const result = Array.from(this.valueList)
      result.splice(index, 1)
      this._emitValue(result)
    },
    onAdd() {
      const result = Array.from(this.valueList)
      result.push(null)
      this._emitValue(result)
    },
    onInputItem(value, index) {
      const result = Array.from(this.valueList)
      result[index] = value
      this._emitValue(result)
    },
  },
}
</script>

<style lang="less" scoped>
@import '~@/styles/common';

.item-action {
  position: relative;
  top: 10px;
}

.drag-handle {
  padding: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.drag-icon {
  width: 100%;
  padding-top: 16px;
}

.sortable-chosen {
  background: lighten(@antBlue, 30%);
}

.sortable-drag {
  background: lighten(@antBlue, 10%);
}
</style>
